import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  PLATFORM_ID,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

import { Subscription } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { unsubscribe } from '@fcom/core/utils/unsubscribe';
import { HtmlString } from '@fcom/core-api/interfaces/cms-interface';

@Component({
  selector: 'fin-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InputCheckboxComponent implements OnInit, OnDestroy {
  private document = inject<Document>(DOCUMENT);
  private platform = inject(PLATFORM_ID);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  group: UntypedFormGroup;
  @Input()
  modelName: string;
  @Input()
  name: string;
  @Input()
  translationPrefix: string;
  @Input()
  block = false;
  @Input()
  useLabelContent = false;
  @Input()
  labelClass = 'font-body-medium';
  @Input()
  hideError = false;
  @Input()
  errorClasses = '';
  @Input()
  containerClass = '';
  @Input()
  innerHtml: HtmlString;
  @Input()
  required: boolean;
  @Input()
  labelDataTestId: string;

  @Output()
  focus: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  blur: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  checkboxChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('inputElement', { static: true })
  inputElement: ElementRef;

  errorKey: string;
  subscription: Subscription;

  ngOnInit(): void {
    const control = this.group.get(this.modelName);

    this.subscription = control.valueChanges.subscribe((s) => {
      if (isPlatformBrowser(this.platform) && this.inputElement.nativeElement !== this.document.activeElement) {
        this.inputElement.nativeElement.value = s;
      }
    });
    this.subscription.add(
      control.statusChanges.subscribe(() => {
        this.errorKey =
          !this.hideError && control.invalid
            ? [this.translationPrefix, Object.keys(control.errors)[0]].join('.')
            : undefined;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription = unsubscribe(this.subscription);
  }
}
